import { Box, styled, Typography, useTheme } from '@mui/material';
import capitalize from '../../../utils/capitalize';

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  [theme.breakpoints.up('lg')]: {
    textAlign: 'start',
  },
}));

const DescriptionText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.primary.dark,
  fontSize: theme.typography.title.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.h3.fontSize,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.mediumText.fontSize,
  },
}));

const NameText = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.h1.fontWeight,
  color: theme.palette.secondary.text,
  fontSize: theme.typography.title.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.h3.fontSize,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
  },
}));

export const TitleSectionName = ({ user, description }) => {
  return (
    <Container>
      <DescriptionText component={'p'}>
        <NameText component={'span'}>{capitalize(user.name)},</NameText> {description}
      </DescriptionText>
    </Container>
  );
};
